export const initialState = {
    token: "BQCzCkJ16v_NuxPI7T0-mziA_YBDnoh_SEZgIVUuLwar7mL3Hs2mMjJkyY6kiNsyXbXHbtFv0khOrW3xKwuWGwXp0YQrI0wdVCM7nvI_1d4gx-sqeQBqqJcdJtvsFzLN9cwMHrc10_EaBphUAamFAuJLgOyBJ5O5Vwp6PN9gXgjLkKol",
    user: null,
    playlists: [],
    playing: false,
    item: null,
};

const reducer = (state, action) => {
    console.log(action);

    switch (action.type) {
        case "SET_USER":
            return {
                ...state,
                user: action.user,
            };

        case "SET_TOKEN":
            return {
                ...state,
                token: action.token,
            };
        case "SET_SPOTIFY":
            return {
                ...state,
                spotify: action.spotify,
            };
        case "SET_PLAYLISTS":
            return {
                ...state,
                playlists: action.playlists,
            }

        case "SET_DISCOVER_WEEKLY":
            return {
                ...state,
                discover_weekly: action.discover_weekly
            }
        case "SET_PLAYING":
            return {
                ...state,
                playing: action.playing,
            };

        case "SET_ITEM":
            return {
                ...state,
                item: action.item,
            };


        case "SET_TOP_ARTISTS":
            return {
                ...state,
                top_artists: action.top_artists,
            };

        default:
            return state;
    }
};


export default reducer;